import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import EnrollmentBasicInfoComponent from './enrollment-basic-info.component';

export const EnrollmentComponent = ({
  parentTopicsList, FileType, handleInnerFormChange, EntityType, Moduleslist, Chapterslist, selectedLmsEnrollment, back, handleFormSubmit, ModuleId
}: any) => {

  const tabItems = [
    {
      id: 1,
      title: 'Enrollments Basic Information',
      component: <EnrollmentBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedLmsEnrollment={selectedLmsEnrollment}
        parentTopicsList={parentTopicsList}
        ModuleId={ModuleId}
        EntityType={EntityType}
        Moduleslist={Moduleslist}
        Chapterslist={Chapterslist}
        FileType={FileType}
      />,
      isVisible: true,
    },
  ]

  return (
    <>
      <TabContainer tabItems={tabItems} />
      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Save
        </button>
      </div>
    </>
  )
}

export default EnrollmentComponent;

